import axios, { AxiosHeaders } from "axios";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { getConfigUI } from "resbutler-ui/init";

let authInterceptorId: number | null = null;
let restoredUserPromise: Promise<firebase.User | null> | null = null;

const waitForRestoredUser = (): Promise<firebase.User | null> => {
  if (!restoredUserPromise) {
    restoredUserPromise = new Promise((resolve) => {
      const unsubscribe = firebase.auth().onAuthStateChanged((restoredUser) => {
        unsubscribe();
        resolve(restoredUser);
      });
    });
  }
  return restoredUserPromise;
};

const installAuthInterceptor = () => {
  if (authInterceptorId !== null) return;
  authInterceptorId = axios.interceptors.request.use(async (req) => {
    const config = getConfigUI();
    const user = firebase.auth().currentUser ?? (await waitForRestoredUser());
    if (!config || !user) return req;

    const token = await user.getIdToken();
    const headers = req.headers instanceof AxiosHeaders ? req.headers : new AxiosHeaders(req.headers);
    headers.set("client-id", config.client);
    headers.set("Authorization", `Bearer ${token}`);
    req.headers = headers;
    return req;
  });
};

// Installs the auth interceptor DURING RENDER, not in an effect
const useRefreshToken = () => {
  installAuthInterceptor();
};

export default useRefreshToken;
